import { render, staticRenderFns } from "./StemdoerPage.vue?vue&type=template&id=4b28dbd2"
import script from "./StemdoerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StemdoerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b28dbd2')) {
      api.createRecord('4b28dbd2', component.options)
    } else {
      api.reload('4b28dbd2', component.options)
    }
    module.hot.accept("./StemdoerPage.vue?vue&type=template&id=4b28dbd2", function () {
      api.rerender('4b28dbd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/shared/stemdoer/StemdoerPage.vue"
export default component.exports